import cookies from "js-cookie";

export const setCookie = (
  name: string,
  value: string,
  options?: Cookies.CookieAttributes
) => {
  cookies.set(name, value, options);
};

export const getCookie = (name: string) => {
  return cookies.get(name);
};

export const getSubCookieDomain = (): string => {
  const host = window.location.hostname;
  const domainParts = host.split(".");
  if (domainParts.length === 1) {
    return "localhost";
  }
  if (domainParts.length === 2) {
    return `.${host}`;
  }
  domainParts.shift();
  return `.${domainParts.join(".")}`;
};

export const getRidersSessionIdFromCookie = () => {
  const mode = import.meta.env.MODE;
  const platform = import.meta.env.VITE_PLATFORM;
  
  if (platform === "mebkit") {
    return getCookie("mebkitsessionid");
  }

  if (mode === "staging") {
    return getCookie("stagingsessionid");
  } else if (mode === "stembox") {
    return "stembox";
  } else {
    return getCookie("sessionid");
  }
};
